import { ISelectTemplate } from "../api/customObjectsTypes"
import { getSelectedTaxonomyIds } from "./taxonomyHelpers"


export const getQuerySelector = (selectTemplate: ISelectTemplate) => {
    switch (selectTemplate) {
        case "tags":
            return {
                filters: [
                    { column: "label", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "tagGroup", ColumnType: 1, filterType: 0, sortDescending: false },
                    { column: "company_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "dateSpectrum", ColumnType: 1, filterType: 0, sortDescending: false },
                    { column: "isLabel", ColumnType: 1, filterType: 0, sortDescending: false },
                    { column: "taxonomies", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "dimensionValueReferences", ColumnType: 1, filterType: 1, sortDescending: false },
                ],
                page: 1,
                pageCount: 20,
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "header":
        case "labels":
        case "tableItems":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "searchLabel", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "elementReference_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "company_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "tagGroup", ColumnType: 1, filterType: 0, sortDescending: false },
                    { column: "dateSpectrum", ColumnType: 1, filterType: 0, sortDescending: false },
                    { column: "lang", ColumnType: 1, filterType: 0, sortDescending: false },
                    { column: "taxonomies", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "dimensionValueReferences_dimensionValue_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "additionalElementReferences", ColumnType: 1, filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "customDimensions":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "valueName", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "company_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "taxonomies", ColumnType: 1, filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "dimensionValue":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "dimension_name", filterType: 1, sortDescending: false },
                    { column: "valueName", filterType: 1, sortDescending: false },
                    { column: "isTypedMember", filterType: 1, sortDescending: false },
                    { column: "isDefaultMember", filterType: 1, sortDescending: false },
                    { column: "company_name", filterType: 1, sortDescending: false },
                    { column: "taxonomies", filterType: 1, sort: true, sortDescending: false },
                    { column: "parentMember_name", filterType: 1, sortDescending: false },
                    { column: "childDimensionValues", filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "elements":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "company_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "taxonomies", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "parentReference_name", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "childElementReferences", ColumnType: 1, filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "settings":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "settingName", filterType: 0, sortDescending: false },
                    { column: "required", columnType: "bool", value: null, filterType: 0, sortDescending: false },
                    { column: "labels", filterType: 1, sort: false, sortDescending: false },
                    { column: "taxonomies", filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "contextSettings":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "context", filterType: 1, sortDescending: false },
                    { column: "period", filterType: 1, sortDescending: false },
                    { column: "taxonomies", filterType: 1, sortDescending: false },
                    { column: "dimensionValueReferences", filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "taxonomyDimensionValues":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "dimension", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "value", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "isTypedMember", ColumnType: 1, filterType: 1, sortDescending: false },
                    { column: "isDefault", ColumnType: 1, filterType: 1, sortDescending: false },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "globalRequests":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "entityReference_name", filterType: 1 },
                    { column: "entity", value: null, filterType: 0 },
                    { column: "company_name", filterType: 1 },
                    { column: "requester_name", value: null, filterType: 0 },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "historyLog":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "reference_name", filterType: 1 },
                    { column: "user_name", filterType: 1 },
                    { column: "type", filterType: 0 },
                    { column: "action", filterType: 0 },
                    { column: "timeStamp", filterType: 1, sort: true, sortDescending: true },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        case "review":
            return {
                page: 1,
                pageCount: 20,
                filters: [
                    { column: "reference_name", filterType: 1 },
                    { column: "company_name", filterType: 1 },
                    { column: "user_name", filterType: 1 },
                    { column: "type", filterType: 0 },
                    { column: "action", filterType: 0 },
                    { column: "timeStamp", filterType: 1, sort: true, sortDescending: true },
                    { column: "reviewed", filterType: 1 },
                ],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
        default:
            return {
                page: 1,
                pageCount: 20,
                filters: [],
                taxonomyIds: getSelectedTaxonomyIds(),
            }
    }
}